import { render } from "./FriendsContent.vue?vue&type=template&id=ec22dc3c"
import script from "./FriendsContent.vue?vue&type=script&lang=js"
export * from "./FriendsContent.vue?vue&type=script&lang=js"

import "./FriendsContent.vue?vue&type=style&index=0&id=ec22dc3c&lang=scss"

import exportComponent from "/Users/dorivaldodossantos/Documents/projectos/meus/ggmf/ggmf_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__